// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__M8WT3","emails":"CreateEditClinics_emails__2_ScG","emailTagLabel":"CreateEditClinics_emailTagLabel__2rIvC"};